<template>
  <div class="page">
    <div class="loading" v-if="isloading">
       <img class="loadimg" width="40" height="40" src="./../assets/loading.svg">
    </div>
     <div class="banner">
         <img src="./../assets/banner17@2x.jpeg">
     </div>
     <div class="listTitle">
         <img class="leftIcon" src="./../assets/leftarrow.png">
         <div class="titleText">{{langText["upcoming"]}}</div>
         <img class="leftIcon" src="./../assets/rightarrow.png">
     </div>
     <div class="listBox" :lang="isArab?'ar' : 'en'" :dir="isArab?'rtl' : 'ltr'">
         <div class="listItem" v-for="(item, index) in listArr" v-bind:key="index">
            <!-- <img class="itembg" src="./../assets/bg@2x.png"> -->
            <div class="imgArea" @click="toProfile(item)">
                <img class="avatar" :src="item.avatar">
                <div class="isInLive" v-if="item.ssid"></div>
            </div>
            <div class="descArea">
                <div class="userName">{{item.name}}</div>
                <p class="descText overhide">{{isArab?item.introduction_ar:item.introduction}}</p>
                <!-- <p class="descText overhide">The spokesman, Zhao Lijian, was quoted by AFP news agency as saying that India had crossed the border twice on Monday, "provoking and attacking Chinese personnel, resulting in serious physical confrontation between border forces on the two sides".</p> -->
                <p class="descText" v-if="showHostTime(item.next_live_time)">{{langText["liveTime"]}}: <span>{{formatTime(item.next_live_time)}}</span></p>
            </div>
            <div class="btnArea" :class="item.subscribed?'inactiveBtn':'activeBtn'" @click="subscribeUser(item)">{{item.subscribed?langText["subscribed"] : langText["subscribe"]}}</div>
         </div>
     </div>
     <div class="listTitle">
         <img class="leftIcon" src="./../assets/leftarrow2.png">
         <div class="titleText2">{{langText["morecome"]}}</div>
         <img class="leftIcon" src="./../assets/rightarrow2.png">
     </div>
     <div class="footer">All rights reserved by Loops</div>
  </div>
</template>

<script>
import {_di} from './../common/js/di';
import {lang} from './../language/kolupcoming';
export default {
  name: 'KOLUpComing',
  data () {
    return {
      isloading: true,
      token: "",
      userId: "",
      host_id: "",
      langType: "",
      isArab: false,
      langText: {},
      kolurl: "",
      listArr: [0,1,2],
      fromType: "",
    }
  },
  created() {
     document.title = "Live schedule";
    //  console.log(this.formatTime(1592215539));
  },
  mounted(){
    this.kolurl = process.env.KOLURL;
    this.userId = this.getUrlParam("userId") || 1004663;
    this.host_id = this.getUrlParam("hostId") || 0;
    this.token = this.getUrlParam("token") || '';
    this.langType = this.getUrlParam('lang') === 'ar' ? 'ar' : 'en';
    this.isArab = this.langType == "ar"?true: false;
    this.langText = lang[this.langType];
    this.fromType = this.getUrlParam("source") || "";
    this.getListInfo();
    //di打点相关
    this.eventTrack = {
        upcoming_subscribe: _di('upcoming.subscribe',42628),
        web_activity_visitor: _di('web.activity.visitor',14226),
        upcoming_profile: _di('upcoming.profile',42629),
    }
    //打点
    this.eventTrack.web_activity_visitor({
        "page": "upcoming",
        "host_id": this.host_id,
        "title": "kol upcoming",
        "source": this.fromType,
    });
    
  },
  methods: {
    getListInfo(){
      var url = this.kolurl + "/kol/landing-info";
      var params = {
        host_id: this.host_id,
        uid: this.userId,
        token: this.token
      };
      this.$axios.get(url, { params: params }).then(response => {
        var resData = response.data;
        console.log(resData)
        this.listArr = resData.hosts;
        this.isloading = false;
        
      });
    },
    subscribeUser(info) {
      var params = {
        host_id: info.uid,
        uid: this.userId
      };
    //   if(this.userDetail.subscribed) {
    //     //打点
    //     this.eventTrack.kol_subsribe_cancel({
    //         "user_id": this.userId,
    //         "host_id": this.host_id,
    //     });
    //   }else{
    //       //打点
    //     this.eventTrack.kol_subsribe({
    //         "user_id": this.userId,
    //         "host_id": this.host_id,
    //     });
    //   }
      var postUrl = info.subscribed ? "/kol/landing-unsubscribe" : "/kol/landing-subscribe";
      var wholeUrl = this.kolurl + postUrl + "?uid=" + this.userId + "&token=" + this.token;
      this.$axios.post(wholeUrl, params).then(response => {
        var resData = response.data;
        console.log(resData);
        this.getListInfo();
        //打点
        this.eventTrack.upcoming_subscribe({
            "uid": this.userId,
            "host_id": info.uid,
            "type": info.subscribed ? 0 : 1,
        });
      });
    },
    showHostTime(time) {
       var nowtime = (new Date().getTime())/1000;
       if(time > nowtime){
           return true
       }else{
           return false
       }
    },
    toProfile(params){
      var linkurl;
        if(!!params.ssid){
          linkurl = encodeURI("loopsmozat://broadcast/openVideo?cid="+params.uid+"&sid="+params.ssid);
        }else{
          //打点
          this.eventTrack.upcoming_profile({
              "uid": this.userId,
              "host_id": params.uid,
          });
          linkurl = encodeURI("loopsmozat://util/openChannelprofile?cid=0&uid="+ params.uid);
        }
        console.log(linkurl)
        window.location.href = linkurl;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    formatTime(time) {
       var now = new Date(time*1000);
       var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var date = now.getDate();
        var hour = (now.getHours() % 12) || 12;
        var minute = now.getMinutes();
        var second = now.getSeconds();
        return  this.pad(month) + "." + this.pad(date) + " " + this.pad(hour) + ":" + this.pad(minute) + " " +(now.getHours() > 11 ? "PM" :"AM") ;
    },
    pad(str) {
      return +str >= 10 ? String(Math.floor(str / 10)) + str % 10 : "0" + str;
    },
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .page{
      width: 100%;
      background: rgb(22, 14, 12);
      min-height: 100vh;
  }
  .loading{
    width: 100vw;
    height:100vh;
    background: #fff;
    position: fixed;
    left: 0;
    top:0;
    z-index: 5;
}
.loadimg{
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -20px;
    margin-left: -20px;
}
  .banner{
      width: 100%;
      /* height: 2.12rem; */
      height: 2.3rem;
      overflow: hidden;
      /* background: url('./../assets/banner2@2x.png');
      background-size: 100%; */
  }
  .banner img {
      width: 100%;
  }
  .listTitle{
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .leftIcon {
      width: 0.96rem;
      height: 0.06rem;
  }
  .titleText{
      /* width: 1rem; */
      padding: 0 0.09rem;
      height: 0.52rem;
      line-height: 0.52rem;
      text-align: center;
      font-size: 0.18rem;
      color: rgb(252, 219, 122);
  }
  .titleText2 {
      /* width: 1rem; */
      padding: 0 0.09rem;
      height: 0.32rem;
      line-height: 0.32rem;
      text-align: center;
      font-size: 0.15rem;
      color: rgb(252, 219, 122);
  }
  .listBox{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .listItem{
      width: 3.55rem;
      height: 1.2rem;
      background: url('./../assets/bg@2x.png');
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.15rem;
      /* position: relative; */
  }
  /* .itembg {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: initial;
  } */
  .imgArea{
      width: 0.75rem;
      height: 0.9rem;
      background: url('./../assets/bg_2@2x.png') no-repeat;
      background-size: 100%;
      background-position: top 0.09rem left 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
  }
  .isInLive{
      width: 0.11rem;
      height: 0.11rem;
      border-radius: 0.06rem;
      background: #6ab846;
      border: 1px solid #fff;
      position: absolute;
      right: 0.07rem;
      bottom: 0.15rem;
  }
  .avatar{
      width: 0.64rem;
      height: 0.64rem;
      border-radius: 0.32rem;
      border: 1px solid rgb(252,218,113);
      object-fit: cover;
  }
  .userName{
      width: 1.8rem;
      height: 0.2rem;
      line-height: 0.2rem;
      font-size: 0.14rem;
      color: rgb(253, 204, 76);
      margin-top: 0.1rem;
      overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      /* background: red; */
  }
  .descArea{
      width: 1.9rem;
      padding: 0 0.04rem;
      /* height: 1rem; */
      /* background: green; */
  }
  .descText{
    line-height: 0.16rem;
    font-size: 0.1rem;
    color: #fff;
  }
  .overhide{
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical; 
    -webkit-line-clamp:4; 
  }
  .descText span {
      color: rgb(236, 43, 122);
  }
  .btnArea{
      width: 0.75rem;
      height: 0.26rem;
      border-radius: 0.13rem;
      line-height: 0.26rem;
      text-align: center;
      font-size: 0.14rem;
  }
  .activeBtn{
    background: rgb(236,43,122);
    color: #fff;
  }
  .inactiveBtn{
    background: rgb(141,141,141);
    color: #fff;
  }
  .footer{
      width: 100%;
      height: 0.24rem;
      line-height: 0.24rem;
      text-align: center;
      font-size: 0.12rem;
      color: rgb(117,115,115);
      margin-top: 0.2rem;
      
  }
</style>


// WEBPACK FOOTER //
// src/page/KOLUpComing.vue